import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FILE_STORAGE_API, API_URL, FILE_STORAGE } from '../../../constants'

// actions
import { getOrderFileSharing, saveOrderFileSharing } from '../../../actions/orderfiles'

// components
import Modal from '../../components/Modal'
import Gallery from '../../components/Gallery'

import Check from '../../elements/check'
import Grid from '../../elements/grid'
import { ModalIcons } from '../../elements/icons'

// utils
import { translation } from '../../../utils/helpers'

// styles
import './handlefilesmodal.scss'

class HandleFilesModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      files: [],
      images: []
    }
    this.onCheckImage = this.onCheckImage.bind(this)
    this.onCheckFile = this.onCheckFile.bind(this)
    this.saveSharing = this.saveSharing.bind(this)
  }

  componentDidMount () {
    this.props.getOrderFileSharing(this.props.orderId).then(res => {
      let files = res.data.filter(x => !x.IsImage)
      let images = res.data.filter(x => x.IsImage)
      this.setState({
        files: files,
        images: images
      })
    })
  }

  onCheckImage (e) {
    const { images } = this.state
    let sharing = e.target.checked ? 1 : 0
    let updatedImages = images.filter(image => {
      if (image.OrderFileID === parseInt(e.target.id)) {
        image.SharingType = sharing
      }
      return images
    })
    this.setState({
      images: updatedImages
    })
  }

  onCheckFile (e) {
    const { files } = this.state
    let sharing = e.target.checked ? 1 : 0
    let updatedFiles = files.filter(file => {
      if (file.OrderFileID === parseInt(e.target.id)) {
        file.SharingType = sharing
      }
      return file
    })

    this.setState({
      files: updatedFiles
    })
  }

  saveSharing () {
    let files = [...this.state.files, ...this.state.images]
    let data = {
      files: files,
      orderId: this.props.orderId
    }
    this.props.saveOrderFileSharing(data)
    this.props.onClose()
  }

  render () {
    const renderImage = (image, index) => {
      let url = FILE_STORAGE + image.ThumbURL
      let fullUrl = FILE_STORAGE + image.FileURL
      return (
        <div key={index} className='file-image'>
          <div className='divImg'>
            <a href={fullUrl} data-lightbox='gallery'>
              <img className='img3' id={image.OrderFileID} name='oldImages' src={url} />
            </a>
          </div>
          <div className='divCheckbox'>
            <Check spacing={0} labelText={translation(1218)} id={image.OrderFileID} name='SharingType' onClick={this.onCheckImage} checked={image.SharingType === 1} />
          </div>
        </div>
      )
    }
    const renderFile = (file, index) => {
      if (file.ActualFileName === null) return null
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      const fileError = () => {
        window.toastr.error(translation('15191'), translation('216'))
      }
      // Return
      return (
        <div key={index} className='file-document clearfix'>
          <Grid spacing={1} cols={['min-content', 'min-content', 1]}>
            <Check name='SharingType' id={file.OrderFileID} onChange={this.onCheckFile} checked={file.SharingType === 1} simple />
            <img className='file-icon' alt='icon' src={thumbUrl} />
            {file.FileExists ? (<a target='_BLANK' href={newFileUrl}>
              {file.FileName}
            </a>) : (
              <a onClick={fileError}>
                {file.FileName}
              </a>
            )}
          </Grid>
        </div>
      )
    }
    return (
      <div className='handlefiles__modal'>
        <Modal {...this.props}
          header={translation(16812)}
          icon={ModalIcons.Note}
          onClose={this.props.onClose}
          show={this.props.show}
          bottomBarProps={{
            actionLabelText: translation(791),
            onActionClick: this.saveSharing
          }}>
          <div>{translation(16813)}</div>
          <div>{this.state.files.map(renderFile)}</div>
          <Gallery files={this.state.images} renderImage={renderImage} />
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { getOrderFileSharing, saveOrderFileSharing })(HandleFilesModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/HandleFilesModal/index.js